import React from 'react';

import { Paper, PaperProps, useMantineTheme } from '@mantine/core';
import BorderSize from 'types/enums';

interface IPageHeaderProps extends PaperProps {
  children: React.ReactNode;
  withoutBorder?: boolean;
}

const PageHeader = ({ children, withoutBorder, ...props }: IPageHeaderProps): JSX.Element => {
  const theme = useMantineTheme();
  return (
    <Paper
      p='lg'
      bg={theme.colors.gray[0]}
      radius={0}
      sx={{
        borderBottom: withoutBorder ? 'none' : `${BorderSize.sm}px solid ${theme.colors.gray[3]}`,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default PageHeader;
